<ng-container *ngIf="userRoll == 3 ">
    <div class="labelLinks">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb bd">
            <li class="breadcrumb-item active" aria-current="page" *ngIf="selectedIbuName && selectedIbuName != 'undefined'">{{ selectedIbuName }}</li>
            <li class="breadcrumb-item active" aria-current="page" *ngIf="selectedFunctionName && selectedFunctionName != 'undefined'
            ">{{ selectedFunctionName }}</li>
            <li class="breadcrumb-item active" aria-current="page" *ngIf="selectedTowerName && selectedTowerName != 'undefined'">{{ selectedTowerName }}</li>
          </ol>
        </nav>
      </div>
</ng-container>